import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M10 5v15a7 7 0 0 0 7 -7","key":"svg-0"}],["path",{"d":"M6 15l8 -4","key":"svg-1"}],["path",{"d":"M14 7l-8 4","key":"svg-2"}]]

/**
 * IconCurrencyLira
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItY3VycmVuY3ktbGlyYSIKPgogIDxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIgLz4KICA8cGF0aCBkPSJNMTAgNXYxNWE3IDcgMCAwIDAgNyAtNyIgLz4KICA8cGF0aCBkPSJNNiAxNWw4IC00IiAvPgogIDxwYXRoIGQ9Ik0xNCA3bC04IDQiIC8+Cjwvc3ZnPg==) - https://tabler.io/icons/icon/currency-lira
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconCurrencyLira = createReactComponent('outline', 'currency-lira', 'CurrencyLira', __iconNode);

export default IconCurrencyLira;